import type { CompileArgs, CompileResult } from "@softr-io/vibe-compiler";

export async function compileVibeBlock(args: CompileArgs): Promise<CompileResult> {
    const mod = await import(/* webpackChunkName: "vibe-compiler" */ "@softr-io/vibe-compiler");
    return mod.compile(args);
}

// Exposing for local dev so we can experiment with compilation edge cases
// more easily instead of waiting for LLM forever.
if (process.env.NODE_ENV !== "production") {
    window.compileVibeBlock = compileVibeBlock;
}

declare global {
    interface Window {
        compileVibeBlock?: typeof compileVibeBlock;
    }
}
